/**
 * Dependencies.
 */
import '@mdi/font/css/materialdesignicons.min.css';

import {
  mdiAccount,
  mdiAccountMultiple,
  mdiAlert,
  mdiAlertCircle,
  mdiBarcodeScan,
  mdiCardAccountDetailsOutline,
  mdiCheck,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarkedCircle,
  mdiCheckboxMarkedOutline,
  mdiCheckCircle,
  mdiChevronDoubleDown,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClockTimeFour,
  mdiContentCopy,
  mdiCrosshairsGps,
  mdiDelete,
  mdiDolly,
  mdiEmailOutline,
  mdiEyeCheck,
  mdiEyeRemove,
  mdiFormatListBulleted,
  mdiForum,
  mdiHome,
  mdiInformation,
  mdiInformationOutline,
  mdiLogout,
  mdiMagnify,
  mdiMapMarker,
  mdiMapMarkerOffOutline,
  mdiMedal,
  mdiNavigation,
  mdiPackage,
  mdiPackageDown,
  mdiPackageUp,
  mdiPackageVariantClosed,
  mdiPencil,
  mdiPhone,
  mdiPhoneOutline,
  mdiQrcodeScan,
  mdiSend,
  mdiStar,
  mdiThumbDown,
  mdiThumbDownOutline,
  mdiThumbUp,
  mdiThumbUpOutline,
  mdiTruck,
  mdiTruckOutline,
  mdiWindowClose
} from '@mdi/js';
import { registerIcons } from '@prz-dp/ui-next';

/**
 * Register icons.
 */
registerIcons({
  mdiAccount,
  mdiAccountMultiple,
  mdiAlert,
  mdiAlertCircle,
  mdiBarcodeScan,
  mdiCardAccountDetailsOutline,
  mdiCheck,
  mdiCheckCircle,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarkedCircle,
  mdiCheckboxMarkedOutline,
  mdiChevronDoubleDown,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClockTimeFour,
  mdiContentCopy,
  mdiCrosshairsGps,
  mdiDelete,
  mdiDolly,
  mdiEmailOutline,
  mdiEyeCheck,
  mdiEyeRemove,
  mdiFormatListBulleted,
  mdiForum,
  mdiHome,
  mdiInformation,
  mdiInformationOutline,
  mdiLogout,
  mdiMagnify,
  mdiMapMarker,
  mdiMapMarkerOffOutline,
  mdiMedal,
  mdiNavigation,
  mdiPackage,
  mdiPackageDown,
  mdiPackageUp,
  mdiPackageVariantClosed,
  mdiPencil,
  mdiPhone,
  mdiPhoneOutline,
  mdiQrcodeScan,
  mdiSend,
  mdiStar,
  mdiThumbDown,
  mdiThumbDownOutline,
  mdiThumbUp,
  mdiThumbUpOutline,
  mdiTruck,
  mdiTruckOutline,
  mdiWindowClose
});
